import { render, staticRenderFns } from "./helpDetails.vue?vue&type=template&id=519c7e0d&scoped=true"
import script from "./helpDetails.vue?vue&type=script&lang=js"
export * from "./helpDetails.vue?vue&type=script&lang=js"
import style0 from "./helpDetails.vue?vue&type=style&index=0&id=519c7e0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519c7e0d",
  null
  
)

export default component.exports